export const rangoFechas = {
  desde: "From",
  hasta: "To",
  etiqueta: "Dates",
  quitar: "Clear dates",
  titulo: "Choose dates",
  elegirInicio: "Tap the first day",
  elegirFin: "Now tap the last day",
  dias: "day | days",
  anterior: "Previous month",
  siguiente: "Next month",
  cancelar: "Cancel",
  aplicar: "Apply",
};
